<template>
  <div
    id="kt_modal_st_consultar"
    ref="kt_modal_st_consultar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Situação Tributária</h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.$emit('exibirModalST', false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <h4 class="text-primary ms-4">Origem</h4>
          <div class="card border border-rounded border-gray-300 mb-4 p-6">
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStOrigem"
                    id="rb0"
                    value="0"
                    v-model="this.chkStOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb0">
                    0 - Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStOrigem"
                    id="rb1"
                    value="1"
                    v-model="this.chkStOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb1">
                    1 - Estrangeira - Importação direta, exceto a indicada no
                    código 6
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStOrigem"
                    id="rb2"
                    value="2"
                    v-model="this.chkStOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb2">
                    2 - Estrangeira - Adquirida no mercado interno, exceto a
                    indicada no código 7
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStOrigem"
                    id="rb3"
                    value="3"
                    v-model="this.chkStOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb3">
                    3 - Nacional, mercadoria ou bem com Conteúdo de Importação
                    superior a 40% (quarenta por cento) e inferior ou igual a
                    70% (setenta por cento)
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStOrigem"
                    id="rb4"
                    value="4"
                    v-model="this.chkStOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb4">
                    4 - Nacional, cuja produção tenha sido feita em conformidade
                    com os processos produtivos básicos de que tratam o
                    Decreto-Lei nº 288/67, e as Leis nºs 8.248/1991, 8.387/1991,
                    10.176/2001 e 11.484/2007
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStOrigem"
                    id="rb5"
                    value="5"
                    v-model="this.chkStOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb5">
                    5 - Nacional, mercadoria ou bem com Conteúdo de Importação
                    inferior ou igual a 40% (quarenta por cento)
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStOrigem"
                    id="rb6"
                    value="6"
                    v-model="this.chkStOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb6">
                    6 - Estrangeira - Importação direta, sem similar nacional,
                    constante em lista de Resolução CAMEX e gás natural
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStOrigem"
                    id="rb7"
                    value="7"
                    v-model="this.chkStOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb7">
                    7 - Estrangeira - Adquirida no mercado interno, sem similar
                    nacional, constante em lista de Resolução CAMEX e gás
                    natural
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-0">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStOrigem"
                    id="rb8"
                    value="8"
                    v-model="this.chkStOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb8">
                    8 - Nacional, mercadoria ou bem com Conteúdo de Importação
                    superior a 70% (setenta por cento)
                  </label>
                </div>
              </div>
            </div>
          </div>
          <h4 class="text-primary ms-4">Tributação</h4>
          <div class="card border border-rounded border-gray-300 mb-0 p-6">
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStTributacao"
                    id="rb00"
                    value="00"
                    v-model="this.chkStTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb00">
                    00 - Tributada integralmente
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStTributacao"
                    id="rb10"
                    value="10"
                    v-model="this.chkStTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb10">
                    10 - Tributada e com cobrança de ICMs por Substituição
                    Tributária
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStTributacao"
                    id="rb20"
                    value="20"
                    v-model="this.chkStTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb20">
                    20 - Com Redução da Base de Cálculo
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStTributacao"
                    id="rb30"
                    value="30"
                    v-model="this.chkStTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb30">
                    30 - Isenta ou não Tributada e com cobrança de ICMs por
                    Substituição Tributária
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStTributacao"
                    id="rb40"
                    value="40"
                    v-model="this.chkStTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb40">
                    40 - Isenta
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStTributacao"
                    id="rb41"
                    value="41"
                    v-model="this.chkStTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb41">
                    41 - Não Tributada
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStTributacao"
                    id="rb50"
                    value="50"
                    v-model="this.chkStTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb50">
                    50 - Com Suspenção
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStTributacao"
                    id="rb51"
                    value="51"
                    v-model="this.chkStTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb51">
                    51 - Diferimento
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStTributacao"
                    id="rb60"
                    value="60"
                    v-model="this.chkStTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb60">
                    60 - ICMs cobrado anteriormente por Substituição Tributária
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStTributacao"
                    id="rb70"
                    value="70"
                    v-model="this.chkStTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb70">
                    70 - Com redução de base de cálculo de ICMs por Substituição
                    Tributária
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-0">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbStTributacao"
                    id="rb90"
                    value="90"
                    v-model="this.chkStTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb90">
                    90 - Outras
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-success svg-icon-white mb-2"
            data-bs-dismiss="modal"
            @click="confirmarST()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["exibirModalST", "confirmarST"],
  props: {
    st: { type: String, required: true },
  },
  methods: {
    confirmarST() {
      this.$emit("confirmarST", this.chkStOrigem + this.chkStTributacao);
    },
  },
  async mounted() {
    var cst = this.st;
    if (this.st === null || this.st.length != 3) {
      cst = "000";
    }
    this.chkStOrigem = cst.substring(0, 1);
    this.chkStTributacao = cst.substring(1, 3);
  },
  data() {
    return {
      chkStOrigem: "0",
      chkStTributacao: "00",
    };
  },
};
</script>

<style></style>
